module.exports = __webpack_public_path__ + "static/media/align-alt.dc00301b.svg";